import React from 'react'

function Home () {
  return <div />
}

export default Home
